import React, { useEffect, useRef } from 'react'
import { ZoomMtg } from '@zoom/meetingsdk'
import { useSelector } from 'react-redux'

const Zoom = ({ signature, id }) => {
    const { user } = useSelector(state => state.user)

    const REACT_APP_ZOOM_MSDK_KEY = "WLUbdeiCQKaGPfloy0muQw"
    const LEAVE_URL = "http://localhost:3000/"

    const queryParams = new URLSearchParams(window.location.search);
    const mn = id;
    const pw = queryParams.get("meetingPassword");
    const callbackUrl = queryParams.get("callbackURL");
    const role = "0";

    useEffect(() => {
        ZoomMtg.setZoomJSLib("https://kingster-dev-public.s3.ap-south-1.amazonaws.com/zoom/dist/lib", "/av");
        ZoomMtg.preLoadWasm();
        ZoomMtg.prepareWebSDK();

        // Set up the beforeunload event listener
        const handleBeforeUnload = (event) => {
            // Show a confirmation dialog
            const confirmLeave = window.confirm('If you navigate away, the meeting will end. Do you want to leave the meeting?');
            if (confirmLeave) {
                // User confirmed, leave the meeting
                leaveMeeting();
            } else {
                // User canceled, prevent navigation
                event.preventDefault();
                return 'Are you sure you want to leave the meeting?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        // Clean up on unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [])

    useEffect(() => {
        if (signature) {
            startMeeting(signature)
        }

        return () => {
            if (signature) {

            }
        }
    }, [signature])



    async function startMeeting(signature) {
        document.getElementById("zmmtg-root").style.display = "block";

        ZoomMtg.init({
            leaveUrl: callbackUrl,
            patchJsMedia: true,
            // leaveOnPageUnload: true,
            success: (success) => {
                console.log(success);
                // can this be async?
                ZoomMtg.join({
                    signature: signature,
                    sdkKey: REACT_APP_ZOOM_MSDK_KEY,
                    meetingNumber: mn,
                    passWord: pw,
                    userName: user?.name || "Student",
                    // userEmail: userEmail,
                    // tk: registrantToken,
                    // zak: zakToken,
                    success: (success) => {
                        console.log(success);
                    },
                    error: (error) => {
                        console.log(error, "erorrr---------------");
                    },
                });
            },
            error: (error) => {
                console.log(error);
            },
        });
    }

    const leaveMeeting = () => {
        if (ZoomMtg && ZoomMtg.leaveMeeting) {
            ZoomMtg.leaveMeeting({
                confirm: false, // No confirmation dialog within the leaveMeeting method
                success: () => {
                    console.log('Successfully left the meeting');
                },
                error: (err) => {
                    console.error('Error leaving the meeting:', err);
                },
            });
        } else {
            console.warn('Zoom SDK is not initialized or meeting object is null');
        }
    };

    return (
        <>
            <div id="zmmtg-root"></div>
        </>
    )
}

export default Zoom